import {SingleLayerSettingsHelp} from "../singleLayer/SingleLayerSettingsHelp";
import React, {useState} from "react";
import {Divider, Segmented} from "antd";
import {DownCircleOutlined, UpCircleOutlined} from "@ant-design/icons";
import {SingleLayerSettingsHelpContent} from "../singleLayer/SingleLayerSettingsHelpContent";

export function SplitViewLayerSettingsHelp({
                                               dataOne,
                                               dataTwo,
                                               colorMapOneName,
                                               colorMapTwoName,
                                               openDrawer
                                           }) {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [isRightView, setIsRightView] = useState(true)

    function onChangeView(value) {
        setIsRightView(value === 'Right')
    }


    return (
        <div
            style={{
                position: 'fixed',
                right: openDrawer ? 540 : 40,
                bottom: 40,
                backgroundColor: '#fff',
                padding: 12,
                backgroundClip: 'padding-box',
                borderRadius: '8px',
                boxShadow: '0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)',
                overflow: 'hidden',
                zIndex: 100,
                transition: 'all 0.3s ease-in-out',
            }}>
            <div
                onClick={() => setIsCollapsed(!isCollapsed)}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                }}><h4 style={{
                minWidth: 177,
                marginBottom: 8,
                color: 'rgba(0, 0, 0, 0.88)',
                fontWeight: 600,
                margin: "5px 0 0 0",
            }}>Legend</h4>
                {isCollapsed
                    ? <UpCircleOutlined style={{color: '#898989'}}/>
                    : <DownCircleOutlined style={{color: '#898989'}}/>}
            </div>
            {!isCollapsed && <Divider style={{margin: "15px 0"}}></Divider>}
            {!isCollapsed && !isRightView && dataOne && <SingleLayerSettingsHelpContent
                data={dataOne}
                colorMapName ={colorMapOneName} />}
            {!isCollapsed && isRightView && dataTwo && <SingleLayerSettingsHelpContent
                data={dataTwo}
                colorMapName ={colorMapTwoName} />}
            {!isCollapsed && <div style={{height: 30}}></div>}
            {!isCollapsed && <Segmented
                style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                }}
                defaultValue="Right"
                options={["Left", "Right"]}
                size="small"
                onChange={onChangeView}
                block/> }
        </div>
    )
}